<app-logiciel-caisse-stock-toolbar
  #toolbar
  (filtersChange)="onFiltersChange($event)"
></app-logiciel-caisse-stock-toolbar>

<app-lc-table-shell [loading]="loading" [hasRows]="tableRows.length > 0">
<div class="table-full-width">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th>Référence</th>
          <th>Code barre</th>
          <th>Désignation</th>
          <th>Prix de vente</th>
          <th>Famille</th>
          <th>Stock physique</th>
          <th>Stock disponible</th>
          <th style="width: 80px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <app-lc-table-skeleton
          *ngIf="loading && tableRows.length === 0"
          [cols]="8"
        ></app-lc-table-skeleton>

        <ng-container *ngFor="let row of tableRows; let i = index">
          <tr
            class="lc-stock-parent-row"
            [class.row-has-children]="hasChildren(row)"
            [class.row-expanded]="isExpanded(i)"
            (click)="onParentRowClick($event, i, row)"
          >
            <td>
              <span class="ref-cell">
                <span
                  class="chevron"
                  [class.chevron-open]="isExpanded(i)"
                  [class.chevron-hidden]="!hasChildren(row)"
                  (click)="toggleExpand($event, i, row)"
                >
                  <i data-feather="chevron-right" [size]="16"></i>
                </span>
                <span>{{ cell(row, 'REFERENCE') }}</span>
              </span>
            </td>
            <td>{{ cell(row, 'CODE BARRE') }}</td>
            <td><span class="designation-cell">{{ cell(row, 'DESIGNATION') }}</span></td>
            <td>{{ cell(row, 'PRIX DE VENTE') }}</td>
            <td>{{ cell(row, 'FAMILLE') }}</td>
            <td>
              <span [ngClass]="stockQtyBadgeClasses(row['STOCK PHYSIQUE'])">
                {{ cell(row, 'STOCK PHYSIQUE') }}
              </span>
            </td>
            <td>
              <span [ngClass]="stockQtyBadgeClasses(row['STOCK DISPONIBLE'])">
                {{ cell(row, 'STOCK DISPONIBLE') }}
              </span>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-outline-primary"
                title="Détail stock par entrepôt"
                (click)="openStockDetail(row); $event.stopPropagation()"
              >
                <i data-feather="eye" [size]="16"></i>
              </button>
            </td>
          </tr>

          <tr
            *ngFor="let child of childRows(row)"
            class="child-row lc-stock-child-row"
            [hidden]="!isExpanded(i)"
            (dblclick)="onChildRowDblClick($event, child)"
          >
            <td>{{ cell(child, 'REFERENCE') }}</td>
            <td>{{ cell(child, 'CODE BARRE') }}</td>
            <td><span class="designation-cell">{{ cell(child, 'DESIGNATION') }}</span></td>
            <td>{{ cell(child, 'PRIX DE VENTE') }}</td>
            <td>{{ cell(child, 'FAMILLE') }}</td>
            <td>
              <span [ngClass]="stockQtyBadgeClasses(child['STOCK PHYSIQUE'])">
                {{ cell(child, 'STOCK PHYSIQUE') }}
              </span>
            </td>
            <td>
              <span [ngClass]="stockQtyBadgeClasses(child['STOCK DISPONIBLE'])">
                {{ cell(child, 'STOCK DISPONIBLE') }}
              </span>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-outline-primary"
                title="Détail stock par entrepôt"
                (click)="openStockDetail(child); $event.stopPropagation()"
              >
                <i data-feather="eye" [size]="16"></i>
              </button>
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="!loading && tableRows.length === 0" class="lc-empty-row">
          <td colspan="8">Pas de données à afficher</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</app-lc-table-shell>

<app-logiciel-caisse-pos-pagination
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  [totalItems]="serverTotal"
  [pageSize]="pageSize"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
></app-logiciel-caisse-pos-pagination>

<div class="lc-stock-pagination-spacer"></div>

<div
  class="stock-detail-overlay"
  *ngIf="stockDetailOpen"
  (click)="closeStockDetail()"
>
  <div class="stock-detail-dialog" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
    <div class="stock-detail-header">
      <h2 class="stock-detail-title">Stock par entrepôt</h2>
      <button type="button" class="stock-detail-close" (click)="closeStockDetail()" aria-label="Fermer">✕</button>
    </div>
    <p class="stock-detail-subtitle">{{ stockDetailTitle }}</p>
    <div class="stock-detail-body">
      <p *ngIf="stockDetailLoading" class="text-muted mb-0">Chargement…</p>
      <ng-container *ngIf="!stockDetailLoading">
        <p *ngIf="stockDetailLines.length === 0" class="text-muted mb-0">
          Aucune ligne de stock pour ce périmètre (filtre établissement / entrepôt ou produits).
        </p>
        <table *ngIf="stockDetailLines.length > 0" class="stock-detail-table">
          <thead>
            <tr>
              <th>Entrepôt</th>
              <th class="num">Physique</th>
              <th class="num">Disponible</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let line of stockDetailLines">
              <td>{{ line.entrepot_libelle }}</td>
              <td class="num">{{ formatStockQty(line.stock_physique) }}</td>
              <td class="num">{{ formatStockQty(line.stock_disponible) }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>
</div>
